import { toK } from '@/utils'
import { ref } from 'vue'

export function useTickersCellFormatter() {
  const formattingRules = ref({
    symbol: (v: any) => {
      return v.split('/')[0]
    },
    vol24h: (v: any) => {
      return toK(v)
    },
    change: (v: any) => {
      return `${Number(v).toFixed(2)}%`
    },
  })
  return { formattingRules }
}
